import React from 'react'
import { FormFieldProps } from '../Common/form/formField/_props'
import FormField from '../Common/form/formField/FormField'
import { UserData } from './_props'
import { useFormContextUser } from './utils/_utils'
import { uneditableRppsRelatedFieldInfo } from '../../utils/stringUtils'

const UserFormField = <T,>(props: FormFieldProps<UserData, T>) => {
    const { name, locked, tooltipTitle } = props
    const { resetField } = useFormContextUser()
    const handleClear = () => {
        if (name) {
            resetField(name, {
                defaultValue: '',
                keepDirty: true,
                keepError: false,
                keepTouched: true,
            })
        }
    }

    const computedTooltipTitle = React.useMemo(() => {
        if (tooltipTitle) {
            return tooltipTitle
        }

        return locked ? uneditableRppsRelatedFieldInfo : undefined
    }, [locked, tooltipTitle])

    return <FormField {...props} tooltipTitle={computedTooltipTitle} onClear={handleClear} />
}

export default UserFormField
